import React from 'react';
import { ArrowLeftIcon } from 'lucide-react';
import { LanguageSwitcher } from '../components/LanguageSwitcher';
import { SEO } from '../components/SEO';
import { breadcrumbSchema } from '../utils/structuredData';
export function ImprintPage() {
  const structuredData = [breadcrumbSchema([{
    name: 'Home',
    url: 'https://close-crm-agentur.de'
  }, {
    name: 'Imprint',
    url: 'https://close-crm-agentur.de/en/imprint'
  }])];
  return <>
      <SEO title="Imprint" description="Legal notice and contact details for Close CRM Agentur." canonical="https://close-crm-agentur.de/en/imprint" noindex={true} structuredData={structuredData} data-id="element-520" />
      <div className="min-h-screen bg-[#0a0a0a]" data-id="element-521">
        <header className="fixed top-0 left-0 right-0 z-50 bg-[#0a0a0a]/80 backdrop-blur-lg border-b border-white/5" data-id="element-522">
          <nav className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8" data-id="element-523">
            <div className="flex items-center justify-between h-14 sm:h-16 lg:h-20 gap-2 sm:gap-4" data-id="element-524">
              <a href="/" className="flex items-center gap-1.5 sm:gap-2 flex-shrink-0 sm:flex-1" aria-label="Close CRM Agentur homepage" data-id="element-525">
                <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-lg bg-[#0ea5e9] flex items-center justify-center flex-shrink-0" data-id="element-526">
                  <span className="text-white font-bold text-xs sm:text-sm" data-id="element-527">
                    C
                  </span>
                </div>
                <span className="text-white font-bold text-sm sm:text-base lg:text-lg whitespace-nowrap" data-id="element-528">
                  Close CRM Agentur
                </span>
              </a>
              <LanguageSwitcher className="absolute right-3 sm:relative sm:right-0" data-id="element-529" />
              <a href="/" className="hidden sm:flex items-center justify-center gap-2 text-gray-400 hover:text-white transition-colors text-sm flex-shrink-0" data-id="element-530">
                <ArrowLeftIcon className="w-4 h-4" data-id="element-531" />
                Back to homepage
              </a>
            </div>
          </nav>
        </header>

        <main className="pt-24 pb-16" data-id="element-532">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-533">
            <div className="prose prose-invert prose-lg max-w-none" data-id="element-534">
              <h1 className="text-4xl font-bold text-white mb-8" data-id="element-535">Imprint</h1>
              <div className="space-y-8 text-gray-300" data-id="element-536">
                <section data-id="element-537">
                  <h2 className="text-2xl font-bold text-white mb-4" data-id="element-538">
                    Company address
                  </h2>
                  <p className="leading-relaxed" data-id="element-539">
                    CRM Kraft LLC
                    <br data-id="element-540" />
                    Represented by: Justus Kraft
                    <br data-id="element-541" />
                    7901 4th St. N, Ste. 300
                    <br data-id="element-542" />
                    St. Petersburg, FL 33702
                    <br data-id="element-543" />
                    United States of America
                  </p>
                </section>

                <section data-id="element-544">
                  <h2 className="text-2xl font-bold text-white mb-4" data-id="element-545">
                    Contact
                  </h2>
                  <p className="leading-relaxed" data-id="element-546">
                    Phone:{' '}
                    <a href="tel:+4915735999071" className="text-[#0ea5e9] hover:underline" data-id="element-547">
                      +49 157 35999071
                    </a>
                    <br data-id="element-548" />
                    Email:{' '}
                    <a href="mailto:justus@crm-kraft.de" className="text-[#0ea5e9] hover:underline" data-id="element-549">
                      justus@crm-kraft.de
                    </a>
                  </p>
                </section>

                <section data-id="element-550">
                  <h2 className="text-2xl font-bold text-white mb-4" data-id="element-551">
                    EU dispute resolution
                  </h2>
                  <p className="leading-relaxed" data-id="element-552">
                    The European Commission provides an online dispute
                    resolution platform:{' '}
                    <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#0ea5e9] hover:underline" data-id="element-553">
                      https://ec.europa.eu/consumers/odr/
                    </a>
                    . Our email address can be found above in this imprint.
                  </p>
                </section>

                <section data-id="element-554">
                  <h2 className="text-2xl font-bold text-white mb-4" data-id="element-555">
                    Consumer dispute resolution
                  </h2>
                  <p className="leading-relaxed" data-id="element-556">
                    We are neither willing nor obliged to participate in dispute
                    resolution proceedings before a consumer arbitration board.
                  </p>
                </section>
              </div>
            </div>
          </div>
        </main>

        <footer className="bg-[#0a0a0a] border-t border-white/5 py-8" data-id="element-557">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-558">
            <p className="text-gray-600 text-sm" data-id="element-559">
              © {new Date().getFullYear()} Close CRM Agentur. All rights
              reserved.
            </p>
          </div>
        </footer>
      </div>
    </>;
}